import tippy, {createSingleton} from "tippy.js"
import "tippy.js/dist/tippy.css"
import "tippy.js/themes/translucent.css"

import options, {tooltipSelector as selector} from "./tooltipOptions"

document.addEventListener("DOMContentLoaded", (e) => {
  // Options are applied to 'tippy' and 'createSingleton' too.
  tippy.setDefaultProps(options)
  const instances = tippy(selector)

  // No waiting for tooltips that are next to each other.
  const singleton = createSingleton(instances)
  instances.forEach((instance) => {
    instance.singleton = singleton
  })
})
